import { addMembersToOrganizationBulkActionEvent, changeMembersInOrganizationActionEvent, changeMembersRoleAndStatusBulkActionEvent, changeMembersRoleBulkActionEvent, removeMembersFromOrganizationBulkActionEvent, } from '../../../../backend/features/audit/shared';
import { useContactManagementTranslation } from '../../../../ui/hooks';
export const useAdditionalEventTypes = () => {
    const { t } = useContactManagementTranslation();
    return [
        { value: addMembersToOrganizationBulkActionEvent, label: t('panels.organizations.audit.addMembers') },
        { value: changeMembersRoleBulkActionEvent, label: t('panels.organizations.audit.changeMembersRole') },
        { value: changeMembersRoleAndStatusBulkActionEvent, label: t('panels.organizations.audit.changeMembersRoleAndStatus') },
        { value: removeMembersFromOrganizationBulkActionEvent, label: t('panels.organizations.audit.removeMembers') },
        { value: changeMembersInOrganizationActionEvent, label: t('panels.organizations.audit.changeMembers') },
    ];
};
